import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isPlay: false,
  backLoad:false
}

export const learningJourneySlice = createSlice({
  name: 'learning_journey',
  initialState,
  reducers: {
    setIsPlay: (state, action) => {
      state.isPlay = action.payload;
    },
    setBackLoad: (state, action) => {
      state.backLoad = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setIsPlay, setBackLoad } = learningJourneySlice.actions

export default learningJourneySlice.reducer